<template>
    <div class="public-offer-order-item">
        {{ offer.title }}
        <b>
            <template v-if="offer.is_free && showFreeTitle">
                <!--                - -->
                <!--                {{ t("payments.public-offer.free") }}-->
            </template>
            <template v-else-if="!offer.is_free">
                &nbsp;
                <s v-if="offer.has_discount && offer.cost_info"> {{ offer.cost_info.price.amount_formatted }}</s>
                {{ offer.price_info.price.amount_formatted }}
            </template>
        </b>
    </div>
</template>

<script>
export default {
    props: {
        offer: {
            type: Object,
            required: true,
            default: () => {}
        },
        showFreeTitle: {
            type: Boolean,
            default: false
        }
    },
    name: "PublicOfferOrderItem"
}
</script>

<style scoped lang="sass">
.public-offer-order-item
    padding: 10px 0
    font-size: 14px
    font-family: Inter, sans-serif
    font-weight: 400
    line-height: 24px
    color: #52565C
    b
        font-weight: 700
        color: #52565C
    s
        color: #B5C1D2
        font-weight: 500
</style>
